import React, {Component} from 'react';
import {Formik} from "formik";
import * as Yup from 'yup';

import {PasswordInput, TextInput, TextInputDisabled} from "./formikComponents";
import {Button, Form} from "antd";

class UserProfile extends Component {
  render() {
    const { onSubmit, current } = this.props;
    return (
      <Formik
        initialValues={current || {}}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit && onSubmit(values);
        }}
        validationSchema={Yup.object().shape({
          password: Yup.string()
            .required('You must enter a password.')
            .min(8, 'Your password must be at least 8 characters.')
            .matches(/[a-z]/, 'Your password must have a lower-case letter in it.')
            .matches(/[A-Z]/, 'Your password must have an upper-case letter in it.')
            .matches(/[0-9]/, 'Your password must have a number in it.')
            .matches(/[^a-zA-Z0-9]/, 'Your password must have a special character in it.'),
          firstname: Yup.string().required('You must enter your first name.'),
          lastname: Yup.string().required('You must enter your last name.')
        })}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {props => {
          const {
            // eslint-disable-next-line
            values, touched, errors, isSubmitting, handleChange, handleBlur, dirty, validate,
            handleSubmit,
          } = props;
          return (
            <Form id='user-registration' onSubmit={handleSubmit}>
              <TextInput
                {...props}
                placeholder='First Name'
                name='firstname'
              />
              <TextInput
                {...props}
                placeholder='Last Name'
                name='lastname'
              />
              <TextInput
                {...props}
                placeholder='Middle Name'
                name='middlename'
              />
              <TextInput
                {...props}
                placeholder='Title'
                name='title'
              />
              <TextInput
                {...props}
                placeholder='Phone'
                name='phone'
              />
              <TextInput
                {...props}
                placeholder='Cell'
                name='cell'
              />
              <TextInput
                {...props}
                placeholder='Fax'
                name='fax'
              />
              <PasswordInput
                {...props}
                placeholder='Create password'
                name='password'
              />
              <TextInputDisabled {...props} placeholder='Your username is your email address.' />
              <Form.Item>
                <Button type='primary' className='full-width' onClick={handleSubmit}>Submit</Button>
              </Form.Item>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

UserProfile.propTypes = {};

export default UserProfile;



// WEBPACK FOOTER //
// ./src/components/Boilerplate/UserProfile.js